import { Box, styled } from '@mui/material';

export const LeftComponentsHeader = styled(Box)`
    display: flex;
    justify-content: flex-start;
    flex: 37%;
`;

export const MiddleComponentsHeader = styled(Box)`
    display: flex;
    justify-content: center;
    flex: 26%;
`;

export const RightComponentsHeader = styled(Box)`
    display: flex;
    justify-content: flex-end;
    flex: 37%;
`;

export const Header = styled('header')`
    background-color: ${({ theme }) => theme.palette.blue.dark};
    padding: 0 30px;
    height: 80px;
    width: 100%;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
`;
